import { render, staticRenderFns } from "./Base-Remote-Select.vue?vue&type=template&id=67f3b8e8&"
import script from "./Base-Remote-Select.vue?vue&type=script&lang=js&"
export * from "./Base-Remote-Select.vue?vue&type=script&lang=js&"
import style0 from "./Base-Remote-Select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports